<template>
  <div>
    <!-- <div class="notes">注: 以下页数按A4单面计算，双面、A3自动2倍，双色计入彩色</div> -->
    <Alert type="warning" style="width: 612px;padding-right: 16px;font-size:12px">
      提示：以下页数按A4单面计算，A3和双面将自动2倍A4，双色计入彩色
      <Button type="success" style="margin-left: 96px;" @click="openPdf">查看填写指引</Button>
    </Alert>
    <Form ref="formInline" :model="itemData" :rules="rule" :label-width="160" inline>
      <FormItem prop="name" label="方案名称:">
        <Input style="width:141px" v-model="data.name" placeholder="抄表结算方案名称"/>
      </FormItem>
      <FormItem prop="basics" label="基础金额(元):">
        <InputNumber style="width:141px" :active-change="false" :precision="2" :min="0" :step="1" v-model="data.basics"/>
      </FormItem>
      <br/>
      <FormItem prop="black_num" label="免费黑白(页):">
        <InputNumber @on-blur="formatContent()" style="width:141px" v-model="itemData.black_num" :active-change="false" :min="0" :precision="0"/>
      </FormItem>
      <FormItem prop="color_num" label="免费彩色(页):">
        <InputNumber @on-blur="formatContent()" style="width:141px" v-model="itemData.color_num" :active-change="false" :min="0" :precision="0"/>
      </FormItem>
      <br/>
      <FormItem label="结算方案描述">
        <Input style="width: 141px" v-model="data.describe"/>
      </FormItem>
      <br/>
      <FormItem label="黑白(页):">
        <div class="type3_row">
          阶梯1: 大于或等于
          <InputNumber @on-blur="formatContent()" v-model="itemData.black.a.m" class="input" :min="0" :precision="0" :active-change="false"/>
          单价(元/页):
          <InputNumber v-model="itemData.black.a.money" class="input" :min="0" :precision="2" :active-change="false"/>
        </div>
        <div class="type3_row">
          阶梯2: 大于或等于
          <InputNumber @on-blur="formatContent()" v-model="itemData.black.b.m" class="input" :min="0" :precision="0" :active-change="false"/>
          单价(元/页):
          <InputNumber v-model="itemData.black.b.money" class="input" :min="0" :precision="2" :active-change="false"/>
        </div>
        <div class="type3_row">
          阶梯3: 大于或等于
          <InputNumber @on-blur="formatContent()" v-model="itemData.black.c.m" class="input" :min="0" :precision="0" :active-change="false"/>
          单价(元/页):
          <InputNumber v-model="itemData.black.c.money" class="input" :min="0" :precision="2" :active-change="false"/>
        </div>
      </FormItem>
      <FormItem label="彩色(页):">
        <div class="type3_row">
          阶梯1: 大于或等于
          <InputNumber @on-blur="formatContent()" v-model="itemData.color.a.m" class="input" :min="0" :precision="0" :active-change="false"/>
          单价(元/页):
          <InputNumber v-model="itemData.color.a.money" class="input" :min="0" :precision="2" :active-change="false"/>
        </div>
        <div class="type3_row">
          阶梯2: 大于或等于
          <InputNumber @on-blur="formatContent()" v-model="itemData.color.b.m" class="input" :min="0" :precision="0" :active-change="false"/>
          单价(元/页):
          <InputNumber v-model="itemData.color.b.money" class="input" :min="0" :precision="2" :active-change="false"/>
        </div>
        <div class="type3_row">
          阶梯3: 大于或等于
          <InputNumber @on-blur="formatContent()" v-model="itemData.color.c.m" class="input" :min="0" :precision="0" :active-change="false"/>
          单价(元/页):
          <InputNumber v-model="itemData.color.c.money" class="input" :min="0" :precision="2" :active-change="false"/>
        </div>
      </FormItem>
      <br/>
      <FormItem>
        <Button type="success" @click="save"  v-preventReClick :loading="loading">保存</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'type3',
  props: {
    data: Object
  },
  data () {
    return {
      loading: false,
      rule: {
        name: [{ validator: (rule, value, cb) => {
          if (!this.data.name) {
            cb(new Error('方案名称未填'))
          } else {
            cb()
          }
        },
        required: true,
        trigger: 'blur' }],
        basics: [{ validator: (rule, value, cb) => {
          if (this.data.basics >= 0) {
            cb()
          } else {
            cb(new Error('基础金额未填'))
          }
        },
        required: true,
        trigger: 'blur' }]
      },
      itemData: {
        black_num: null,
        color_num: null,
        black: {
          a: { m: null, money: null },
          b: { m: null, money: null },
          c: { m: null, money: null }
        },
        color: {
          a: { m: null, money: null },
          b: { m: null, money: null },
          c: { m: null, money: null }
        }
      }
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    openPdf () {
      window.open('https://www.aidprint.com/pdf/jt.pdf')
    },
    initData () {
      if (this.data.id && this.data.type == 3) {
        this.itemData = JSON.parse(this.data.content)
      }
    },
    save () {
      this.$refs.formInline.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.data.agent_id = this.user.id
          this.data.content = JSON.stringify(this.itemData)
          this.data.type = '3'
          this.SaveMeterCharge(this.data).then(res => {
            if (res) {
              this.data.id = res
              this.$Message.success('保存成功')
            }
            this.loading = false
          })
        }
      })
    },
    formatContent () {
      // if(this.itemData.black_num && (this.itemData.black.a.m === null || this.itemData.black.a.m < this.itemData.black_num)){
      //   this.itemData.black.a.m = this.itemData.black_num + 1
      // }
      // if(this.itemData.color_num && (this.itemData.color.a.m === null || this.itemData.color.a.m < this.itemData.color_num)){
      //   this.itemData.color.a.m = this.itemData.color_num + 1
      // }
      let types = ['black', 'color'],
        rows = ['a', 'b', 'c']
      types.map(type => {
        rows.map((row, index) => {
          if (index !== 0) {
            if (this.itemData[type][rows[index]].m <= this.itemData[type][rows[index - 1]].m) {
              this.itemData[type][rows[index]].m = null
            }
          }
        })
      })
    },
    ...mapActions(['SaveMeterCharge'])
  },
  computed: mapGetters({
    user: 'agent'
  })
}
</script>

<style lang="less" scoped>
  @import '../index.less';
</style>
